// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__V2KT4","disabled":"FileBtn_disabled__32V6F","warn":"FileBtn_warn__2mbQy","fade":"FileBtn_fade__22hZZ"};